import fetchAPI from '../fetchAPI';
import { AiModel, AiModelPayload } from './callGetAiModels';

type SaveResponse = iResponse<{ code: number; data?: AiModel; message?: string }>;

/** Create a model (no id) or update one (with id). The name is immutable. */
export const callSaveAiModel = async (payload: AiModelPayload, id?: string): Promise<SaveResponse> =>
  id
    ? fetchAPI({ method: `PATCH`, route: `ai-models`, id, data: payload as unknown as APIData })
    : fetchAPI({ method: `POST`, route: `ai-models`, data: payload as unknown as APIData });

export default callSaveAiModel;
